import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hoursAmPm',
})
export class HoursAmPmPipe implements PipeTransform {
  transform(value: number): string {
    const ampm = value < 12 ? 'am' : 'pm';
    return `${value == 12 ? 12 : value % 12}:00${ampm}`;
  }
}
